/** Persisted on the dynamic node `value` (Lexical JSON); keys match `Column.type`. */
export function getColumnWidthsFromValue(value: unknown): Record<string, number> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }
  const raw = (value as {columnWidths?: unknown}).columnWidths;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }
  const out: Record<string, number> = {};
  for (const [k, v] of Object.entries(raw as Record<string, unknown>)) {
    if (typeof v === 'number' && Number.isFinite(v)) {
      out[k] = v;
    }
  }
  return out;
}

export function attachPreservedColumnWidths(nextValue: unknown, previousValue: unknown): unknown {
  const widths = getColumnWidthsFromValue(previousValue);
  if (Object.keys(widths).length === 0) {
    return nextValue;
  }
  if (typeof nextValue === 'number') {
    return {v: nextValue, columnWidths: {...widths}};
  }
  if (nextValue && typeof nextValue === 'object' && !Array.isArray(nextValue)) {
    return {...(nextValue as Record<string, unknown>), columnWidths: {...widths}};
  }
  return nextValue;
}

export function omitColumnWidthsFromValue(cur: unknown): unknown {
  if (typeof cur === 'number') {
    return cur;
  }
  if (!cur || typeof cur !== 'object' || Array.isArray(cur)) {
    return cur;
  }
  const o = cur as Record<string, unknown>;
  const rest = {...o};
  delete rest.columnWidths;
  return Object.keys(rest).length === 0 ? {} : rest;
}

export function valueWithUpdatedColumnWidths(
  cur: unknown,
  widths: Record<string, number>
): unknown {
  if (Object.keys(widths).length === 0) {
    return omitColumnWidthsFromValue(cur);
  }
  const base = omitColumnWidthsFromValue(cur);
  if (typeof base === 'number') {
    return {v: base, columnWidths: {...widths}};
  }
  if (base && typeof base === 'object' && !Array.isArray(base)) {
    return {...(base as Record<string, unknown>), columnWidths: {...widths}};
  }
  return {columnWidths: {...widths}};
}
